import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
  preLoad: 1.33, // 预加载的宽高比例
  error: require('../pages/img/lazyload.png'), // 图片加载失败展示的图片
  loading: require('../pages/img/lazyload.png'), // 图片加载中展示的图片
  attempt: 2, // 尝试加载的次数
  throttleWait: 500 // 间隔多少时间重新加载
});
